export default function makeSelectTable(store) {
  return {
    selectTable: function selectTable(editor, tableId) {
      var cells = editor.getTableCells(tableId);
      var selectedCellKeys = cells.map(function (cell) {
        return cell.key;
      });
      var selectedCellsCoords = editor.getCellsCoords(cells);
      store.updateItem(store.getItem('lastFocusedTableId'), {});
      store.updateItem('lastFocusedTableId', tableId);
      store.updateItem(tableId, {
        selected: true,
        selectedCellKeys: selectedCellKeys,
        selectedCellsCoords: selectedCellsCoords
      });
      return editor.snapshotSelection().withoutSaving(function () {
        return editor.deselect();
      });
    }
  };
}